import React from "react";
import "../styles/vp-supplier-type.css";
import icon from "../../../assets/vp-supplier-type-icon.png";
import VPCustomRadioCard from "./VPCustomRadioCard";
import multiUserLight from "../../../assets/multi-user-light.svg";
import userLight from "../../../assets/user_light.svg";
function VPSupplierType({ userInfo }) {
  return (
    <div className="vp-supplier-type mb-3">
      <div className="card">
        <div className="card-header">
          <div className="d-flex align-items-center">
            <img width={22} height={22} src={icon} alt="icon" />
            <h5 className="m-0 ms-2 vp-supplier-type-title">Supplier Type</h5>
          </div>
        </div>
        <div className="card-body">
          <p className="vp-supplier-type-sub-title">
            Are you a company or a freelancer?
          </p>
          {userInfo?.data?.supplier?.supplier_type === "Company" ? (
            <VPCustomRadioCard
              icon={multiUserLight}
              text1="Yes, I am a representative of a registered company"
              text2="Choose this if your company is registered under a govt law of incorporation"
            />
          ) : (
            <VPCustomRadioCard
              icon={userLight}
              text1="No, I am a freelancer"
              text2="You are doing this business as a freelancer or as a broker and doesn't represent a company"
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default VPSupplierType;
